
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/information",
      function () {
        return require("private-next-pages/information.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/information"])
      });
    }
  